import { render, staticRenderFns } from "./PaxBlock.vue?vue&type=template&id=17f7474b&"
import script from "./PaxBlock.vue?vue&type=script&lang=js&"
export * from "./PaxBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports